import React, { PureComponent } from 'react'
import { Field } from 'redux-form'
import { Panel } from 'react-bootstrap'
import InputSelect from '../../../components/commons/form/InputSelect'
import InputText from '../../../components/commons/form/InputText'
import InputDatePicker from '../../../components/commons/form/InputDatePicker'
import InputMoney from '../../../components/commons/form/InputMoney'
import { permissions, clientInformation } from '../../../constants/backendIds'
import { getFieldsPermisions } from '../../../util/permisionFunctions'
import { compareObjects, getDateNowMaxDatePicker } from '../../../util/utils'
import setting from '../../../setting'
import CustomFields from '../../../components/commons/customFields/CustomFields'
import ComponentTitle from '../../../containers/dossiers/commons/ComponentTitlePage'

class ServiceComponent extends PureComponent {
  constructor () {
    super()
    this.state = {
      panelOpen: true,
      entityDisabled: true,
      fieldsConfiguration: {
        providerObservations: null,
        saleObservations: null,
        serviceAmount: null,
        invoiceDate: null,
        billingNumber: null,
        ORNumber: null,
        place: null,
        confirmedDate: null,
        requiredDate: null,
        availabilityDate: null,
        applicationDate: null,
        entitySubTypeId: null,
        entityId: null,
        orderDate: null,
        destinationId: null
      }
    }
  }

  initializePermisions (props) {
    const fieldKeys = Object.keys(this.state.fieldsConfiguration)
    const newState = getFieldsPermisions(props.componentConfiguration.fieldsConfiguration, fieldKeys, props.componentConfiguration.permission)
    this.setState({ fieldsConfiguration: newState.fieldsConfiguration })
  }

  componentDidMount () {
    this.initializePermisions(this.props)
    if (this.props.dossier.dossierServiceComponent.entitySubTypeId) {
      this.setState({ entityDisabled: false })
    }
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.dossier && this.props.dossier.dossierId && !compareObjects(prevProps.componentConfiguration || {}, this.props.componentConfiguration, true)) {
      this.initializePermisions(this.props)
    }

    if (!prevProps.summaryOpen && this.props.summaryOpen) {
      this.setState({ panelOpen: true })
    }
    return prevProps
  }

  onRecurrentTypeIdChanges (entitySubTypeId) {
    if (entitySubTypeId) {
      this.props.actions.fetchEntityFilterSubTypeCombo(5, entitySubTypeId, this.props.dossier.organizedUnitId)
      this.setState({ entityDisabled: false })
    } else {
      this.props.actions.change('dossierServiceComponent.entityId', null)
      this.setState({ entityDisabled: true })
    }
  }

  componentDidUpdate () {
    // don't remove use for getsnapshot
  }

  togglePanel () {
    this.setState({ panelOpen: !this.state.panelOpen })
  }

  render () {
    const {
      t, customFields, combos: { entitySubTypeCombo, entityFilterSubTypeCombo, destinationCombo },
      readOnlyFields
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.SERVICE_DOSSIER.'
    return (
      <div className="dossier-Component">
        <div className="header-panel" onClick={this.togglePanel.bind(this)}>
          <ComponentTitle
            componentCode="SERVICES_COMPONENT"
            componentOpen={this.state.panelOpen}
          />
        </div>
        <Panel expanded={this.state.panelOpen} onToggle={() => {}} >
          <Panel.Collapse>
            <div style={{ zIndex: 2 }} className='fieldsContainer'>
              {this.state.fieldsConfiguration.destinationId && this.state.fieldsConfiguration.destinationId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="destinationId"
                  name="dossierServiceComponent.destinationId"
                  key="dossierServiceComponent.destinationId"
                  controlLabel={t(`${tKey}SERVICE_COMPONENT.DESTINY`)}
                  placeholder={t(`${tKey}SERVICE_COMPONENT.DESTINY`)}
                  options={destinationCombo}
                  valueKey="id"
                  labelKey="value"
                  disabled={this.state.fieldsConfiguration.destinationId.permission !== permissions.editable || readOnlyFields}
                />
              )}
              {this.state.fieldsConfiguration.entitySubTypeId && this.state.fieldsConfiguration.entitySubTypeId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="entitySubTypeId"
                  name="dossierServiceComponent.entitySubTypeId"
                  key="dossierServiceComponent.entitySubTypeId"
                  controlLabel={t(`${tKey}SERVICE_COMPONENT.TYPE`)}
                  placeholder={t(`${tKey}SERVICE_COMPONENT.TYPE`)}
                  onInputChange={this.onRecurrentTypeIdChanges.bind(this)}
                  options={entitySubTypeCombo}
                  valueKey="id"
                  labelKey="value"
                  disabled={this.state.fieldsConfiguration.entitySubTypeId.permission !== permissions.editable || readOnlyFields}
                />
              )}
              {this.state.fieldsConfiguration.entityId && this.state.fieldsConfiguration.entityId.permission !== permissions.hidden && (
                <Field
                  component={InputSelect}
                  colWidth={33} // 25, 33, 50, 75, 100 default=25
                  id="entityId"
                  name="dossierServiceComponent.entityId"
                  key="dossierServiceComponent.entityId"
                  controlLabel={t(`${tKey}SERVICE_COMPONENT.ENTITY`)}
                  placeholder={t(`${tKey}SERVICE_COMPONENT.ENTITY`)}
                  options={entityFilterSubTypeCombo}
                  valueKey="id"
                  labelKey="value"
                  disabled={this.state.entityDisabled || this.state.fieldsConfiguration.entityId.permission !== permissions.editable || readOnlyFields}
                />
              )}
            </div>
            <div style={{ zIndex: 1 }} className="fieldsContainer">
              {this.state.fieldsConfiguration.orderDate && this.state.fieldsConfiguration.orderDate.permission !== permissions.hidden && (<Field
                component={InputDatePicker}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                maxDate={getDateNowMaxDatePicker()}
                id="applicationDate"
                name="dossierServiceComponent.orderDate"
                controlLabel={t(`${tKey}SERVICE_COMPONENT.ORDER_DATE`)}
                placeholder={t(`${tKey}SERVICE_COMPONENT.ORDER_DATE`)}
                disabled={this.state.fieldsConfiguration.orderDate.permission !== permissions.editable || readOnlyFields}
                customClass={this.state.fieldsConfiguration.orderDate.permission !== permissions.editable || readOnlyFields ? 'disabled' : ''}
              />)}
              {this.state.fieldsConfiguration.availabilityDate && this.state.fieldsConfiguration.availabilityDate.permission !== permissions.hidden && (<Field
                component={InputDatePicker}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="availabilityDate"
                name="dossierServiceComponent.availabilityDate"
                controlLabel={t(`${tKey}SERVICE_COMPONENT.AVAILABITY_DATE`)}
                placeholder={t(`${tKey}SERVICE_COMPONENT.AVAILABITY_DATE`)}
                disabled= { this.state.fieldsConfiguration.availabilityDate.permission !== permissions.editable || readOnlyFields}
                customClass={this.state.fieldsConfiguration.availabilityDate.permission !== permissions.editable || readOnlyFields ? 'disabled' : ''}
              />)}
              {this.state.fieldsConfiguration.requiredDate && this.state.fieldsConfiguration.requiredDate.permission !== permissions.hidden && (<Field
                component={InputDatePicker}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="requiredDate"
                name="dossierServiceComponent.requiredDate"
                controlLabel={t(`${tKey}SERVICE_COMPONENT.REQUIRED_DATE`)}
                placeholder={t(`${tKey}SERVICE_COMPONENT.REQUIRED_DATE`)}
                disabled= { this.state.fieldsConfiguration.requiredDate.permission !== permissions.editable || readOnlyFields}
                customClass={this.state.fieldsConfiguration.requiredDate.permission !== permissions.editable || readOnlyFields ? 'disabled' : ''}
              />)}
              {this.state.fieldsConfiguration.confirmedDate && this.state.fieldsConfiguration.confirmedDate.permission !== permissions.hidden && (<Field
                component={InputDatePicker}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="confirmedDate"
                name="dossierServiceComponent.confirmedDate"
                controlLabel={t(`${tKey}SERVICE_COMPONENT.CONFIRMED_DATE`)}
                placeholder={t(`${tKey}SERVICE_COMPONENT.CONFIRMED_DATE`)}
                disabled= { this.state.fieldsConfiguration.confirmedDate.permission !== permissions.editable || readOnlyFields || (setting.clientFieldValidation === clientInformation.VGR) }
                customClass={this.state.fieldsConfiguration.confirmedDate.permission !== permissions.editable || readOnlyFields || (setting.clientFieldValidation === clientInformation.VGR) ? 'disabled' : ''}
              />)}
              {this.state.fieldsConfiguration.place && this.state.fieldsConfiguration.place.permission !== permissions.hidden && (<Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="place"
                name="dossierServiceComponent.place"
                controlLabel={t(`${tKey}SERVICE_COMPONENT.PLACE`)}
                placeholder={t(`${tKey}SERVICE_COMPONENT.PLACE`)}
                disabled= { this.state.fieldsConfiguration.place.permission !== permissions.editable || readOnlyFields}
              />)}
              {this.state.fieldsConfiguration.ORNumber && this.state.fieldsConfiguration.ORNumber.permission !== permissions.hidden && (<Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="ORNumber"
                name="dossierServiceComponent.orNumber"
                controlLabel={t(`${tKey}SERVICE_COMPONENT.ORNUMBER`)}
                placeholder={t(`${tKey}SERVICE_COMPONENT.ORNUMBER`)}
                disabled= { this.state.fieldsConfiguration.ORNumber.permission !== permissions.editable || readOnlyFields}
              />)}
              {this.state.fieldsConfiguration.billingNumber && this.state.fieldsConfiguration.billingNumber.permission !== permissions.hidden && (<Field
                component={InputText}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="billingNumber"
                name="dossierServiceComponent.billingNumber"
                controlLabel={t(`${tKey}SERVICE_COMPONENT.BILLING_NUMBER`)}
                placeholder={t(`${tKey}SERVICE_COMPONENT.BILLING_NUMBER`)}
                disabled= { this.state.fieldsConfiguration.billingNumber.permission !== permissions.editable || readOnlyFields}
              />)}
              {this.state.fieldsConfiguration.invoiceDate && this.state.fieldsConfiguration.invoiceDate.permission !== permissions.hidden && (<Field
                component={InputDatePicker}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                maxDate={getDateNowMaxDatePicker()}
                id="invoiceDate"
                name="dossierServiceComponent.billingDate"
                controlLabel={t(`${tKey}SERVICE_COMPONENT.BILLING_DATE`)}
                placeholder={t(`${tKey}SERVICE_COMPONENT.BILLING_DATE`)}
                disabled= { this.state.fieldsConfiguration.invoiceDate.permission !== permissions.editable || readOnlyFields}
                customClass={this.state.fieldsConfiguration.invoiceDate.permission !== permissions.editable || readOnlyFields ? 'disabled' : ''}
              />)}
              {this.state.fieldsConfiguration.serviceAmount && this.state.fieldsConfiguration.serviceAmount.permission !== permissions.hidden && (<Field
                component={InputMoney}
                colWidth={33} // 25, 33, 50, 75, 100 default=25
                id="serviceAmount"
                name="dossierServiceComponent.serviceAmount"
                controlLabel={t(`${tKey}SERVICE_COMPONENT.SERVICE_AMOUNT`)}
                placeholder={t(`${tKey}SERVICE_COMPONENT.SERVICE_AMOUNT`)}
                disabled= { this.state.fieldsConfiguration.serviceAmount.permission !== permissions.editable || readOnlyFields}
              />)}
              {this.state.fieldsConfiguration.saleObservations && this.state.fieldsConfiguration.saleObservations.permission !== permissions.hidden && (<Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                componentClass="textarea"
                customClass="textarea-noresize"
                id="saleObservations"
                name="dossierServiceComponent.saleObservations"
                controlLabel={t(`${tKey}SERVICE_COMPONENT.SALE_OBSERVATIONS`)}
                placeholder={t(`${tKey}SERVICE_COMPONENT.SALE_OBSERVATIONS`)}

                disabled= { this.state.fieldsConfiguration.saleObservations.permission !== permissions.editable || readOnlyFields}
              />)}
              {this.state.fieldsConfiguration.providerObservations && this.state.fieldsConfiguration.providerObservations.permission !== permissions.hidden && (<Field
                component={InputText}
                colWidth={50} // 25, 33, 50, 75, 100 default=25
                componentClass="textarea"
                customClass="textarea-noresize"
                id="providerObservations"
                name="dossierServiceComponent.providerObservations"
                controlLabel={t(`${tKey}SERVICE_COMPONENT.PROVIDER_OBSERVATIONS`)}
                placeholder={t(`${tKey}SERVICE_COMPONENT.PROVIDER_OBSERVATIONS`)}
                disabled= { this.state.fieldsConfiguration.providerObservations.permission !== permissions.editable || readOnlyFields}
              />)}
            </div>
            <CustomFields customFields={customFields} readOnlyFields={readOnlyFields} />
          </Panel.Collapse>
        </Panel>
      </div>
    )
  }
}

export default ServiceComponent
